"use strict";

const NumberFormat = (number, fractionDigits) => {
    fractionDigits = fractionDigits || 2;
    return number.toLocaleString(undefined, {maximumFractionDigits:fractionDigits});
};

const PercentageFormat = (number, fractionDigits) => {
    return `${NumberFormat((number * 100), fractionDigits)} %`;
};

export {
    NumberFormat,
    PercentageFormat,
};